import {DG_axiosSpecial} from "../../custom/axios/configSpecial";


const baseURL = `/o/dogoo/merge-name`

export async function addMergeName(databaseKey, data) {
    const response = await DG_axiosSpecial.post(baseURL + "/create" , data, {
        params: {
            databaseKey
        }
    })
    return response?.data.result || []
}

export async function addListMergeName(databaseKey, data) {
    const response = await DG_axiosSpecial.post(baseURL + "/create-list" , data, {
        params: {
            databaseKey
        }
    })
    return response?.data.result || []
}
